exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-title {\r\n    text-align: center;\r\n}\r\n.mat-dialog-actions {\r\n    -webkit-box-pack: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n}\r\nmat-dialog-container {\r\n    position: fixed;\r\n    left: 20%;\r\n    top: 0%;\r\n    background-color: white;\r\n    z-index: 100000;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/common/dialog/confirmdialog.component.css
// module id = ../../../../../src/app/components/common/dialog/confirmdialog.component.css
// module chunks = main